// Saves the in-progress UGC ad (incl. photo files) in IndexedDB while the user buys credits
const DB = "ugc_drafts", STORE = "drafts", KEY = "pending", FLAG = "ugc_return_pending";
const MAX_AGE = 24 * 60 * 60 * 1000;

const withStore = (mode, fn) => new Promise((resolve, reject) => {
  const open = indexedDB.open(DB, 1);
  open.onupgradeneeded = () => open.result.createObjectStore(STORE);
  open.onerror = () => reject(open.error);
  open.onsuccess = () => {
    const req = fn(open.result.transaction(STORE, mode).objectStore(STORE));
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  };
});

export const saveUgcDraft = async (form, step) => {
  await withStore("readwrite", (s) => s.put({ form, step, savedAt: Date.now() }, KEY));
  localStorage.setItem(FLAG, String(Date.now()));
};

export const hasUgcDraft = () => Date.now() - Number(localStorage.getItem(FLAG) || 0) < MAX_AGE;

export const takeUgcDraft = async () => {
  localStorage.removeItem(FLAG);
  const draft = await withStore("readonly", (s) => s.get(KEY));
  await withStore("readwrite", (s) => s.delete(KEY));
  return draft && Date.now() - draft.savedAt < MAX_AGE ? draft : null;
};
